import { getStore } from "../../Providers/store";
import api from "../../Services/Api/api";
import PActions from "../../Stores/redux/Persist/Actions";
import UnpActions from "../../Stores/redux/UnPersist/Actions";
import sleep from "../utils/sleep";
import { sendLogoutSignal } from "./logout";

export const initAuth = async () => {
  let store = getStore();

  if (store) {
    store.dispatch(PActions.fetchMyProfile());
  }
};

export const impersonate = async (userId) => {
  const { token, user } = await api.post(
    `v1/head-office/user/${userId}/impersonate`
  );

  let store = getStore();

  if (store) {
    const state = store.getState();

    store.dispatch(UnpActions.resetVState());
    store.dispatch(
      PActions.setPScreenState("user", {
        token,
        impersonator: state.pState.user,
        user,
      })
    );

    await sleep(200);
    initAuth();
  }
};

export const exitImpersonating = async () => {
  sendLogoutSignal();

  let store = getStore();

  if (store) {
    const state = store.getState();
    const impersonator = state?.pState?.user?.impersonator || {};

    store.dispatch(UnpActions.resetVState());
    store.dispatch(
      PActions.setPScreenState("user", {
        token: null,
        user: null,
        ...impersonator,
        impersonator: null,
      })
    );
  }
};
